export function formatDate(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const timeDiff = now - date;
  const minutesAgo = Math.floor(timeDiff / 60000); // 60000 milliseconds in a minute

  if (minutesAgo < 60) {
    return `${minutesAgo} minutes ago`;
  } else {
    const hoursAgo = Math.floor(minutesAgo / 60);
    if (hoursAgo < 24) {
      return `${hoursAgo} hours ago`;
    } else {
      const options = { month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    }
  }
}
